import { render } from "./KnowledgeSmall.vue?vue&type=template&id=459214b8&scoped=true"
import script from "./KnowledgeSmall.vue?vue&type=script&lang=js"
export * from "./KnowledgeSmall.vue?vue&type=script&lang=js"

import "./KnowledgeSmall.vue?vue&type=style&index=0&id=459214b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459214b8"]])

export default __exports__